import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteApiKeyMutation($input: DeleteApiKeyInput!) {
		deleteApiKey(input: $input) {
			deletedApiKeyId
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: companyId,
			connectionKeys: [
				{
					key: 'Company_apiKeys',
				},
				{
					key: 'PrimaryNavigationRightCompany_apiKeys',
				},
				{
					key: 'AgentDrawer_apiKeys',
				},
			],
			pathToConnection: ['company', 'apiKeys'],
			deletedIDFieldName: 'deletedApiKeyId',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Api Key Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.id}},
		configs: getConfigs(input.companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
